import bookingInitDataStorage from "../init/data-storage";

declare let booking_object: any;

// Interface for the dependencies needed by this class
interface BookingHandlerOptions {
    roomId: string;
    calendarModule: any;
    timeSlotModule: any;
    playersRangeModule: any;
}

export default class roomBooking {
    private options: BookingHandlerOptions;
    private readonly triggerClass: string = 'btn-room-booking';

    constructor(options: BookingHandlerOptions) {
        this.options = options;
    }

    public initialize(): void {
        // console.log('Initializing booking click handler...');
        document.body.addEventListener('click', this._handleBookingClick.bind(this));
    }

    /**
     * Handles the click event, gathers data, and delegates saving/redirecting.
     * @private
     */
    private _handleBookingClick(event: MouseEvent): void {
        const bookButton = (event.target as HTMLElement).closest(`.${this.triggerClass}`);
        if (!bookButton) {
            return;
        }

        event.preventDefault();
        
        const originalButtonHTML = bookButton.innerHTML;
        const loaderSVG = `...`; 
        bookButton.innerHTML = loaderSVG;

        setTimeout(() => {
            const gameId = bookButton.getAttribute('data-game');
            const currentDate = this.options.calendarModule.getDate('dd/mm/y');
            const currentTimeSlot = this.options.timeSlotModule.control?.getValue();
            const currentPlayers = this.options.playersRangeModule.control?.getValue();

            if (!gameId || !currentDate || !currentTimeSlot || !currentPlayers) {
                console.error('Missing data for booking.', { gameId, currentDate, currentTimeSlot, currentPlayers });
                alert('Errore: non è stato possibile recuperare tutti i dati per la prenotazione.');
                bookButton.innerHTML = originalButtonHTML;

                return;
            }

            const bookingData = {
                room_id: this.options.roomId,
                game_id: gameId,
                date: currentDate,
                slot_time: String(currentTimeSlot),
                players: String(currentPlayers),
            };

            // --- DELEGATION: Call the new method to handle saving and redirecting ---
            this._saveDataAndRedirect(bookingData);

        }, 800);
    }

    /**
     * NEW METHOD: Handles saving data to localStorage and redirecting the user.
     * @param {BookingInitData} data - The booking data object to save.
     * @private
     */
    private _saveDataAndRedirect(data): void {
        console.log('Saving booking data to LocalStorage:', data);

        // This method is now responsible for using the storage class
        const dataStorage = new bookingInitDataStorage();
        dataStorage.setLocalStorage(data);
        
        console.log('Redirecting to checkout page...');

        // Redirect to the next page
        window.location.href = booking_object.page_order;
    }
}